<template lang="pug">
  app-toolbar(title="Постановления об этапировании")
    app-toolbar-item(label="Показать" :items="preparedStatuses" key-name="title" min-width="216" @select="filterByStatus") {{ selectedStatus | statusNamed }}
      template(slot="list-item" slot-scope="{ item, index }" ) 
        span.sud-case-status-color(v-bind:style="{ background: statusColor(item) }")
        span.sud-case-filter.text-lowercase {{ item.title }}

    //-app-toolbar-item-period.ml-12(@select="setPeriod") {{ period ? period.text : 'все' }} 
    app-toolbar-item-period.ml-12(@select="handlePeriod" :showAll="false") {{ period ? period.text : 'все' }} 

    app-toolbar-item.ml-12(label="Сортировать" :items="sorter" key-name="title" min-width="120" @select="sortBy") {{ currentSort.title }}

    app-dialog-loading(v-model="updating")
</template>

<script>
import { mapGetters, mapMutations, mapState } from 'vuex';
import { $_app_moment } from "@/common/AppMoment.js"
import DocStatuses from "@/assets/data/DocStatuses.json"

import { AppDialogLoading } from '@/components'

import moment from 'moment'
moment.locale('ru')

export default {
  components: {
    [AppDialogLoading.name]: AppDialogLoading
  },
  mixins: [ $_app_moment ],
  data() {
    return {
      loading: false,
      currentSort: {title: 'по дате'},
      sorter: [
        {title: 'по дате'},
        {title: 'по статусу'}
      ]
    }
  },

  computed: {
    ...mapState('gsu', ['selectedStatus', 'period', 'updating', 'selectedSort']),
    ...mapGetters('gsu', ['statuses', 'isStatusesLoaded']),
    preparedStatuses () {
      let lastColor = 0
      let list = []

      list.push({ title: 'Все', color: 0 })
      list.push({ divider: true })
      for (let index = 0; index < this.statuses.length; index++) {
        const element = this.statuses[index]
      
        if (lastColor != 0 && lastColor != element.color) {
          list.push({ divider: true })
        }
        lastColor = element.color
        list.push(element)
      }
      return list
    }
  },

  methods: {
    ...mapMutations('gsu', [ 'selectStatus', 'setPeriod', 'selectSort']),

    handlePeriod (item) {
      let load = (this.period.start!=item.start || this.period.end!=item.end)? true : false
      this.setPeriod(item)
      if(load) this.$store.dispatch('gsu/LOAD_Ordinances_PERIOD')
    },

    statusColor(item) {
      if (item.color > 0 && item.color < 4) {
        return DocStatuses.colors[item.color]
      }
      return ''
    },

    filterByStatus(status) {
      if (status.title!="Все") 
        this.selectStatus(status)
      else 
        this.selectStatus(null)
    },

    sortBy(item, index) {
      this.currentSort = item
      this.selectSort(index)
    }
  },
  filters: {
    statusNamed: status => {
      return status != null ? status.title : 'Все'
    },
  },

}
</script>


<style lang="scss" scoped>
  .sud-card-text {
    background: #FFFFFF; 
  }

  .sud-case-status-color {
    margin: 0 16px 0 0;
  }
</style>
